<div id="dialog_container" class="small-dialog-container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="center-band center">
    <img
      id="success_icon"
      src="/assets/images/success-icon.svg"
      alt="Success"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">{{ title() }}</div>
      <div id="message">{{ message() }}</div>
    </span>
  </div>
  <hr class="custom-hr" />
  <div id="lower_band" class="lower-band">
    <button
      mat-button
      id="success_button"
      class="blue-button common-button"
      (click)="dialog.close()">
      {{ button() }}
    </button>
  </div>
</div>
